import React from 'react'
import { useLocation, useNavigate } from "react-router-dom";

const ThankYou = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location || {};

  const handleGoBack = () => {
    navigate('/user/subscription')
  }


  const planType = state?.planType || {};

  return (
    <div>
      <div className="thankyou-wrapper">
        <div className="card col-md-7">
          <div className='check-header'>
            <div className="check-container">
              <img style={{ width: '100px' }} src='/assets/images/200w.gif' alt="success" />
            </div>
          </div>
          <h1>Thank You!</h1>
          <p>
            You have successfully subscribed<br />
            the {
              planType?.basket_id
                ? "Basket"
                : planType?.plan_ids
                  ? "Service"
                  : "Plan"
            }.
          </p>
          <button className="btn btn-primary mt-4 w-50 mx-auto" onClick={handleGoBack}>
            Go to Subscription
          </button>
        </div>
      </div>
    </div>
  )
}

export default ThankYou
